import { routes } from '@/routes'
import { useLocales } from '@sevenrooms/locales'
import { Switch, Route } from '@sevenrooms/navigation'
import { ReservationStatus, BookReservation, WidgetContainer, ManageReservationContainer } from '../../components'
import { useVenue } from '../../hooks'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'
import { Manage } from './Manage'

const managePath = routes.reservations.manage

export function ManageReservation() {
  const { formatMessage } = useLocales()
  const { largeLogoUrl, urlKey, name } = useVenue()
  const venueLink = `/reservations/${urlKey}`

  return (
    <WidgetContainer largeLogoUrl={largeLogoUrl} venueName={name} venueLink={venueLink}>
      <ManageReservationContainer portalId="manage-res-portal">
        <Switch>
          <Route path={managePath.canceled.path}>
            <ReservationStatus header={formatMessage(reservationWidgetMessages.resCancelPagePageHeader)}>
              <BookReservation />
            </ReservationStatus>
          </Route>
          <Route path={managePath.passed.path}>
            <ReservationStatus header={formatMessage(reservationWidgetMessages.resCancelPageResPassed)}>
              <BookReservation />
            </ReservationStatus>
          </Route>
          <Route path={managePath.path}>
            <Manage />
          </Route>
        </Switch>
      </ManageReservationContainer>
    </WidgetContainer>
  )
}
